<mat-tab-group>
  <mat-tab label="Frameworks">
    <div class='users-component' style="margin-top: 20px;">
      <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: stretch; margin-left: 40px;">
        <div>
          <mat-form-field class="example-full-width">
            <mat-label>Compliance area</mat-label>
            <mat-select
                        [(ngModel)]="selectedComplianceArea"
                        name="selectedComplianceArea"
                        (ngModelChange)="onComplianceAreaChange($event)">

              <mat-option [value]="NoneComplianceArea">None</mat-option>
              <mat-option *ngFor="let complianceArea of complianceAreas" [value]="complianceArea">
                {{complianceArea.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div>
          <button mat-raised-button (click)="selectedComplianceArea=null">Back to Frameworks</button>
          <button mat-raised-button [matMenuTriggerFor]="appMenu"
                  style="border-radius: 6px;margin-right: 10px;white-space: nowrap; "
                  class="button">
            Actions<span class="mat-select-arrow"
                         style="display:inline-block; width: 0;height: 0;border-left: 5px solid transparent;border-right: 5px solid transparent;border-top: 5px solid;margin: 0 4px;"></span>
          </button>
          <mat-menu #appMenu="matMenu">
            <button mat-menu-item
                    type="button"
                    *ngIf="canManageControlItems"
                    (click)="openCreatePopup()"
                    disabled="{{selectedComplianceArea == null}}">
              Add Control Item
            </button>

            <button mat-menu-item *ngIf="canManageControlItems"
                    matTooltip="{{this.constants.ATTACHMENT_FILE_DESCRIPTION}}"
                    (click)="inputFile.click()"
                    disabled="{{selectedComplianceArea == null}}">
              <i class="pi pi-paperclip"></i>
              Upload Control Items
            </button>
            <input #inputFile
                   type="file"
                   accept="{{this.constants.ATTACHMENT_FILE_EXTENSIONS}}"
                   (change)="uploadControlItems($event)"
                   [style.display]="'none'">
            <button mat-menu-item *ngIf="canManageControlItems"
                    matTooltip="{{this.constants.ATTACHMENT_FILE_DESCRIPTION}}"
                    (click)="inputFile2.click()">
              <i class="pi pi-paperclip"></i>
              Upload Control Items hierarchy
            </button>

            <input #inputFile2
                   type="file"
                   accept="{{this.constants.ATTACHMENT_FILE_EXTENSIONS}}"
                   (change)="uploadControlItemsHierarchy($event)"
                   [style.display]="'none'">
            <button mat-menu-item *ngIf="canManageControlItems"
                    matTooltip="{{this.constants.ATTACHMENT_FILE_DESCRIPTION}}"
                    (click)="inputFile3.click()">
              <i class="pi pi-paperclip"></i>
              Upload Control Items broadcast
            </button>

            <input #inputFile3
                   type="file"
                   accept="{{this.constants.ATTACHMENT_FILE_EXTENSIONS}}"
                   (change)="uploadControlItemsBroadcast($event)"
                   [style.display]="'none'">
            <!--div *ngIf="canManageControlItems"
                 >
                <label
                        class="mat-button"
                        for="uploadControlItems">
                    <i class="pi pi-paperclip"></i> Upload Control Items
                    <input id="uploadControlItems"
                            type="file"
                            [(ngModel)]="upload"
                            (change)="uploadControlItems($event)"
                            onclick="this.value = null"
                            name="uploadControlItems"
                            style="display: none; border-radius: 6px;" />
                </label>
            </div-->

            <button mat-menu-item
                    type="button" *ngIf="canManageControlItems && (updatedAreas > 0)"
                    (click)="gotoControlItemUpdates()">
              {{updatedAreas}} Updated Compliance Areas
            </button>
            <button mat-menu-item *ngIf="selectedComplianceArea != NoneComplianceArea"
                    type="button"
                    (click)="downloadCurrentComplianceArea()">
              Download Compliance Area
            </button>
            <button
              type="button" mat-menu-item
              *ngIf="canUploadComplianceArea && selectedComplianceArea != NoneComplianceArea"
              (click)="uploadCurrentComplianceArea()">
              Modify Current Compliance Area
            </button>
            <button
              type="button" mat-menu-item *ngIf="selectedComplianceArea != NoneComplianceArea"
              (click)="editComplianceArea(selectedComplianceArea)">
              Edit Current Compliance Area
            </button>
            <button *ngIf="canUploadComplianceArea"
                    type="button" mat-menu-item
                    (click)="uploadComplianceArea()">
              Upload New Compliance Area
            </button>
            <button mat-menu-item
                    (click)="deleteArea()"
                    *ngIf="canUploadComplianceArea && selectedComplianceArea != NoneComplianceArea"
            >
              Delete Current Compliance Area
            </button>
            <button mat-menu-item
                    [routerLink]="['/controlItems', 'mapControlItems', selectedComplianceArea.complianceAreaId]"
                    *ngIf="canUploadComplianceArea && selectedComplianceArea != NoneComplianceArea"
            >
              Setup Broadcast
            </button>
            <button mat-menu-item
                    [routerLink]="['/controlItems', 'mapWorkstreamItems', selectedComplianceArea.complianceAreaId]"
                    *ngIf="canUploadComplianceArea && selectedComplianceArea != NoneComplianceArea
                    && (tenantPermissions.isWorkstreamsEnabled || isMaster)">
              Map WS Items
            </button>
            <button mat-menu-item
                    [routerLink]="['/mappingTemplate']"
            >
              Mapping Templates
            </button>
          </mat-menu>
        </div>

      </div>

      <p-table *ngIf="!selectedComplianceArea" [value]="complianceAreas"
               [paginator]="false"
               [reorderableColumns]="true"
               [style]="{'margin-top':'10px'}"
               #table
      >
        <ng-template pTemplate="header">
          <tr style="white-space: nowrap; font-weight: bold;">
            <th>Name</th>
            <th *ngIf="isMaster">Default</th>
            <th>Extended View</th>
            <th>Updated</th>
            <th>Items Count</th>
            <th style="width: 10em;"></th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-item>
          <tr>
            <td>{{item.name}}</td>
            <td *ngIf="isMaster">
              <mat-checkbox [checked]="settings && settings.defaultComplianceAreas.indexOf(item.complianceAreaId) >= 0"
                            (change)="isDefaultUpdate(item, $event)"></mat-checkbox>
            </td>
            <td>
              <mat-checkbox [checked]="item.isExtended" (change)="isExtendedUpdate(item, $event)"></mat-checkbox>
            </td>
            <td>
              {{item.lastModifiedDate | date:'short'}}
            </td>
            <td>
              {{item.itemsCount ? item.itemsCount : '?'}}{{item.parentItemsCount || item.subItemsCount ? '/' + item.parentItemsCount  + '/' + item.subItemsCount : ''}}
            </td>
            <td>
              <button (click)="selectedComplianceArea=item; loadControlItems()" type="button" pButton
                      class="risksponge-button" icon="pi pi-arrow-right"></button>
              <button (click)="editComplianceArea(item)" type="button" pButton class="risksponge-button"
                      icon="pi pi-pencil"></button>
            </td>
          </tr>
        </ng-template>
      </p-table>


      <p-table *ngIf="selectedComplianceArea"
               [value]="controlItems"
               [reorderableColumns]="true"
               [style]="{'margin-top':'10px'}"
               #table
               (onRowReorder)="saveOrder($event)"
               dataKey="category">

        <ng-template pTemplate="header">
          <tr style="white-space: nowrap;font-weight: bold">
            <th style="width: 2em; text-align: center;">
            </th>
            <th style="width:3em">
              <button type="button"
                      pButton
                      class="risksponge-button"
                      (click)="deleteCheckedControlItems()"
                      icon="pi pi-times"
                      style="width: 2em">
              </button>
            </th>
            <th *ngFor="let col of cols" [pSortableColumn]="col.field">
              {{col.header}}
              <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                          ariaLabelDesc="Activate to sort in descending order"
                          ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
            </th>
            <th style="width:5em"></th>
          </tr>
          <tr>
            <th style="width: 2em; text-align: center;">
            </th>
            <th style="width: 2em; text-align: center;">
            </th>
            <th *ngFor="let col of cols" [ngSwitch]="col.field">
              <input *ngSwitchDefault pInputText type="text" placeholder="⌕"
                     (input)="table.filter($event.target['value'], col.field, 'contains')">
              <p-multiSelect *ngSwitchCase="'category'" [options]="categoriesFilter"
                             defaultLabel="All"
                             (onChange)="table.filter($event.value,col.field,'in')"
                             styleClass="ui-column-filter">
              </p-multiSelect>
            </th>
            <th></th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-item let-rowIndex="rowIndex" let-expanded="expanded" let-columns="columns">
          <tr class="ui-widget-header"
              *ngIf="rowGroupMetadata[item.category].index === rowIndex">
            <td colspan="6">
              <a href="#" [pRowToggler]="item">
                <i [ngClass]="expanded ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></i>
                <span>{{item.complianceArea.name}} - {{item.category}}</span>
              </a>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="expandedrow" let-item let-index="rowIndex">
          <tr [pSelectableRow]="item" [pReorderableRow]="index">
            <td>
              <span class="pi pi-bars" pReorderableRowHandle></span>
            </td>
            <td style="text-align: center;">
              <input type="checkbox" [(ngModel)]="item.checked"/>
            </td>
            <td>
              <span href="#" *ngIf="item.subItems?.length" (click)="subVisible[item.complianceAreaControlId] = !subVisible[item.complianceAreaControlId]">
                <i [ngClass]="subVisible[item.complianceAreaControlId] ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></i>
                </span>
              {{item.category}}
            </td>
            <td>{{item.complianceAreaControlId}}</td>
            <td>{{item.description}}</td>
            <td>
              <button
                type="button"
                pButton
                class="risksponge-button"
                (click)="editControlItem(item.controlItemId)"
                icon="pi pi-pencil">
              </button>
            </td>
          </tr>
          <ng-container *ngIf="subVisible[item.complianceAreaControlId]">
            <ng-container *ngFor="let subItem of item.subItems">
              <tr [pSelectableRow]="subItem">
                <td>
                  <span class="pi pi-bars" pReorderableRowHandle></span>
                </td>
                <td style="text-align: center;">
                  <input type="checkbox" [(ngModel)]="subItem.checked"/>
                </td>
                <td style="padding-left: 40px;">
                  {{subItem.category}}
                </td>
                <td style="padding-left: 40px;">{{subItem.complianceAreaControlId}}</td>
                <td>{{subItem.description}}</td>
                <td>
                  <button
                    type="button"
                    pButton
                    class="risksponge-button"
                    (click)="editControlItem(subItem.controlItemId)"
                    icon="pi pi-pencil">
                  </button>
                </td>
              </tr>
            </ng-container>
          </ng-container>
        </ng-template>

      </p-table>

      <div *ngIf="msg" role="alert" class="alert alert-info alert-dismissible">
        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span
          aria-hidden="true">&times;</span>
        </button>
        <span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
        <span class="sr-only">Error:</span>
        {{msg}}
      </div>
    </div>
  </mat-tab>
  <mat-tab label="Rating">
    <div class="row">
      <div class="col-md-6" *ngIf="selectedProject && implementationStatusCount" style="height: 300px;">
        <div class="box">
          <div class="box-header with-border">
            <h3 class="box-title">Benchmark</h3>
          </div>

          <div class="box-body"
               style="height:280px;">
            <div class="row">
              <div class="col-md-4">
                <div class="box-title" style="margin-left: 15px; display: flex; flex-direction: row;">
                  <mat-form-field class="project-list">
                    <mat-select [(ngModel)]="selectedProject"
                                name="projects"
                                (ngModelChange)="onProjectChange($event)">

                      <mat-option *ngFor="let project of projects" [value]="project">
                        {{project.name}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <a
                    href="{{this.config.api + '/api/projects/project/' + selectedProject.projectId + '/implementationstatus' + '?token=' + userToken}}"><img
                    src="../../../assets/icons/square-o/pdf.svg" style="margin-left: 10px;height: 28px;opacity: 0.17"/></a>

                </div>

                <div *ngFor="let i of [0,1,2,3,4,5]">{{implementationStatuses[i]}}
                  : {{implementationStatusCount[i] || 0}}</div>
              </div>

              <div class="col-md-7">
                <div class="chart-responsive" *ngIf="implementationStatusData && implementationStatusBarOptions">
                  <p-chart type="bar"
                           [data]="implementationStatusData"
                           [options]="implementationStatusBarOptions"
                           height="200px" width="100%"
                  >
                  </p-chart>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6" *ngFor="let data of predictionData; index as a" style="height: 300px;">
        <div class="box">
          <div class="box-header with-border">
            <h3 class="box-title">Compliance Framework Forecast: {{predictions[a].complianceArea.name}}</h3>
            <div class="box-title" style="margin-left: 15px;">
            </div>

          </div>

          <div class="box-body"
               style="height:280px;">
            <div class="row">
              <div class="col-md-4">

                <div *ngFor="let i of [0,1,2,3,4,5]">{{implementationStatuses[i]}}
                  : {{predictions[a].statuses[i].count || 0}}</div>
              </div>
              <div class="col-md-8">
                <div class="chart-responsive" *ngIf="predictionData && predictionOptions">
                  <p-chart type="bar"
                           [data]="predictionData[a]"
                           [options]="predictionOptions[a]"
                           height="200px" width="100%"
                  >
                  </p-chart>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </mat-tab>
  <mat-tab label="Mapping" *ngIf="isMappingTemplateVisible">
    <mappingTemplate></mappingTemplate>
  </mat-tab>
</mat-tab-group>
